<template>
    <div>
        <v-container class="">
            <v-card color="#FFEB3B">
                <v-card-title>
                    <div class="subtitle-1">REQUEST ASSIGNMENT FORM</div>
                </v-card-title>
                <v-container class="yellow lighten-3">
                    <quickTicketCheck v-on:get-ticket-info="ticketInfo=$event" :key="refreshQuickCheck"></quickTicketCheck>
                    <!-- Deadline date -->
                    <v-row dense>
                        <v-col cols="7">
                            <div class="body-2 mb-1">納品締切日 / Deadline Date</div>
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="date"
                                    label="Picker in menu"
                                    prepend-inner-icon="event"
                                    readonly
                                    v-on="on"
                                    solo
                                ></v-text-field>
                                </template>
                                <v-date-picker v-model="date" no-title scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="info" @click="menu = false">Cancel</v-btn>
                                <v-btn text color="info" @click="$refs.menu.save(date)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <!-- Deadline Time -->
                        <v-col cols="5">
                            <div class="body-2 mb-1">時間 / Deadline Time (Ex: ○19:00  ×by Noon  ×午前中)</div>
                            <v-text-field
                                v-model="time"
                                label="Enter time as 19:00"
                                solo
                            ></v-text-field>
                        </v-col>
                        <!-- researchers -->
                        <v-col cols="12">
                            <div class="body-2 mb-1">リサーチャー / Researchers</div>
                            <v-autocomplete
                            :items="all_researcher_names_emails"
                            item-text="name"
                            item-value="name"
                            v-model="selectedResearchers"
                            label="Researchers"
                            solo
                            class="body-2"
                            clearable
                            multiple
                            small-chips
                            ></v-autocomplete>
                        </v-col>
                        <!-- English or not -->
                        <v-col cols="1" class="pl-2">
                            <v-row justify="center">
                                <span class="caption">英語</span>
                            </v-row>
                            <v-row justify="center">
                                <v-checkbox
                                v-model="englishOrNot"
                                color="red"
                                value="red"
                                hide-details
                                ></v-checkbox>
                            </v-row>
                        </v-col>
                        <!-- price -->
                        <v-col cols="11">
                            <div class="body-2 mb-1">報酬 / Price</div>
                            <v-select
                                :items = 'salaryWithEnglish'
                                v-model="ticketPrice"
                                label="報酬を選択 / Select the price"
                                solo
                            ></v-select>          
                        </v-col>
                        <!-- comment -->
                        <v-col cols="12">
                            <v-card>
                                <simpleVue2Editor @rich-text-event=richtextHandler($event) />
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card class="pa-3 mb-2 mt-1">
                                <v-card-title>
                                    Comment Preview
                                </v-card-title>
                                <v-divider></v-divider>
                                <div v-html="ticketComment" class="ma-3"/>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="end" class="mr-3">
                        <v-btn small @click="assignTicket2Researchers">送信 / ASSIGN</v-btn>
                    </v-row>
                </v-container>
            </v-card>
        </v-container>
        <v-divider></v-divider>
        <assignedPanel :assign-panel-key="assignPanelKey" @update-assign-panel="assignPanelKey=$event" :key="assignPanelKey"></assignedPanel>
        <v-divider></v-divider>
        <completedPanel :completed-panel-key="completedPanelKey" @update-completed-panel="completedPanelKey=$event" :key="completedPanelKey"></completedPanel>
    </div>
</template>

<script>
/* eslint-disable no-console */
import {db,auth} from '@/fb'
import quickTicketCheck from '@/components/api/quickTicketCheck'
import assignedPanel from '@/components/statusPanels/assignedPanel'
import completedPanel from '@/components/statusPanels/completedPanel'
import simpleVue2Editor from '@/components/editor/simple_vue2editor'
export default {
    name:'ticketAssignment',
    components:{
        quickTicketCheck,
        assignedPanel,
        completedPanel,
        simpleVue2Editor
    },
    data(){
        return{
            refreshQuickCheck:0,
            date: new Date().toISOString().substr(0, 10),
            time:null,
            selectedResearchers:[],
            all_researcher_basic_info:[],
            englishOrNot: false,
            salaryItems: [0,1000,2000,3000,4000,5000],
            ticketComment:null,
            ticketPrice:null,

            ticketInfo:null,

            menu: false,

            assignPanelKey:0,
            completedPanelKey:10000,
        }
    },
    computed:{
        all_researcher_names_emails(){
            var allResearchNames = this.all_researcher_basic_info.map(research=>{
                return {name:research.name[1]+' '+research.name[0],email:research.email}
            })
            return allResearchNames
        },
        all_researcher_names_emails_map(){
            let map = new Map()
            this.all_researcher_basic_info.forEach(el=>{
                map.set(el.name[1]+' '+el.name[0],el.email)
            })
            return map
        },
        all_researcher_names(){
            var allResearchNames = this.selectedResearchers
            return allResearchNames
        },
        all_researcher_emails(){
            var allResearchEmails = this.selectedResearchers.map(researcher=>{
                return this.all_researcher_names_emails_map.get(researcher)
            })
            return allResearchEmails
        },
        salaryWithEnglish(){
            if(this.englishOrNot){
                var salaryItemsEnglish = this.salaryItems.map(salary=>{
                    return salary+500
                })
                return salaryItemsEnglish
            }else{
                return this.salaryItems
            }
        },
    },
    methods:{
        richtextHandler(event){
            this.ticketComment = event
        },
        assignTicket2Researchers(){
            if(this.ticketInfo == null || this.all_researcher_names_emails == null || this.ticketPrice == null || this.ticketComment == null){
                alert('必須項目を全部入力してください')
            }else{
                // final confirm
                if(confirm(`アサインするメンバーを確認してください。Please confirm your assignment. ${this.ticketInfo.data.id} Assign To ${this.selectedResearchers}?`)){
                    let date = new Date();
                    let currentMonthYear = String(date.getMonth()+1)+'/'+String(date.getFullYear());
                    let ref = db.collection('ticket_assigned')
                    ref.doc(String(this.ticketInfo.data.id)).set({
                        ticket_number:this.ticketInfo.data.id,
                        researchers:this.all_researcher_names,
                        researcherEmails:this.all_researcher_emails,
                        assign_time: Date.now(),
                        deadline: this.date+' '+this.time,
                        price: this.ticketPrice,
                        comment: this.ticketComment,
                        researcher_replied:false,
                        ticket_subject:this.ticketInfo.data.subject,
                        ticket_description:this.ticketInfo.data.description_text,
                        assigned_month: currentMonthYear,
                        concierge_in_charge: auth.currentUser.email
                    })
                    .then(()=>{
                        this.ticketInfo = null,
                        this.selectedResearchers = [],
                        this.ticketComment = null,
                        this.date = new Date().toISOString().substr(0, 10),
                        this.time = null,
                        this.ticketPrice= null,
                        this.englishOrNot=false,
                        this.refreshQuickCheck += 1,
                        alert("アサインが完了しました。You have successfully assigned")
                    })
                    .catch(err=>{
                        console.log(err)
                    })
                }else{
                    console.log('cancelled')
                }
            }
        },
    },
    created(){
        let ref = db.collection('researchers')
        ref.get()
        .then(snap=>{
            snap.forEach(doc=>{
                this.all_researcher_basic_info.push(doc.data())
            })
        })
    },
}
</script>